import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray, withFormik } from 'formik';
import { isEmpty, map, uniqueId } from 'lodash';
import Yup from 'yup';
import { getFormValue } from '../../../util/helpers';
import { FormLayout, renderFormSection } from '../../common';
import Diagnosis from './Diagnosis';

const DIAGNOSES = 'diagnoses';

const getNewDiagnosis = () => ({
  custom: '',
  treatingDoctorId: '',
  icd10Code: undefined,
  id: undefined,
  isSearchResult: false,
  tempId: uniqueId('temp-'),
  notes: undefined,
});

function DiagnosisForm(props) {
  return (
    <FormLayout {...props}>
      <FieldArray
        name={DIAGNOSES}
        render={fieldArray =>
          renderFormSection({
            fieldArray,
            props: {
              ...props,
              component: Diagnosis,
              onAddSection: getNewDiagnosis,
              title: 'Diagnosis',
            },
          })
        }
      />
    </FormLayout>
  );
}

DiagnosisForm.propTypes = {
  data: PropTypes.array,
  doctors: PropTypes.array,
};

DiagnosisForm.defaultProps = {
  data: [],
  doctors: [],
};

const toDiagnosisValues = diagnosis => ({
  custom: getFormValue(diagnosis, 'custom', ''),
  treatingDoctorId: getFormValue(diagnosis, 'treatingDoctorId', ''),
  id: diagnosis.id,
  tempId: diagnosis.tempId,
  icd10Code: diagnosis.icd10Code,
  isSearchResult: diagnosis.isSearchResult,
  notes: diagnosis.notes,
});

export default withFormik({
  displayName: 'Diagnosis',
  handleSubmit: (values, { props, setStatus }) => {
    return props
      .onSave(
        values.diagnoses.map(d => {
          if (!d.isSearchResult) d.icd10Code = null;
          else d.custom = null;
          return d;
        }),
      )
      .then(() => (props.isEditing ? props.onCancel() : props.onContinue()))
      .catch(error => setStatus({ saveError: error }));
  },
  mapPropsToValues: ({ data }) => {
    return {
      diagnoses: isEmpty(data)
        ? [getNewDiagnosis()]
        : map(data, toDiagnosisValues),
    };
  },
  validationSchema: Yup.object().shape({
    diagnosis: Yup.array().of(
      Yup.object().shape({
        custom: Yup.string().when('isSearchResult', (isSearchResult, schema) =>
          isSearchResult
            ? schema
            : schema.required('Custom diagnosis name is required.'),
        ),
        icd10Code: Yup.object()
          .nullable()
          .when('isSearchResult', (isSearchResult, schema) =>
            isSearchResult
              ? schema.required('Diagnosis is required.')
              : schema.notRequired(),
          ),
        isSearchResult: Yup.boolean(),
      }),
    ),
  }),
})(DiagnosisForm);



// WEBPACK FOOTER //
// ./src/modules/DiagnosisPage/components/DiagnosisForm.js